import type { NetworkPayload } from "../../../composites";
import type { UserAccessibilityPreferencesPayload } from "./types";

const URL = "me/accessibility_preferences";

export const API = {
  setUserAccessibilityPreferences: (
    payload: UserAccessibilityPreferencesPayload,
  ): NetworkPayload<UserAccessibilityPreferencesPayload> => {
    return {
      url: URL,
      options: {
        payload,
        method: "PUT",
        isJsonResponse: true,
      },
    };
  },
};
